import { useEffect, useRef, useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { LoadingRow } from "./components/loading-row";
import { Button } from "./components/styles/Button.styled";
import { useTranslation } from "react-i18next";
import {
  CommunityItem,
  CommunityItemImage,
  CommunityItemContent,
  CommunityItemContentFooter,
  CommunityItemContentHeader,
  CommunityRow,
  CommunityNavBtn,
  CommunityMobile,
  CommunityDesktop,
  PlanError,
  RenewalPlanAction,
  RenewalPlanInfo,
  RenewalPlanIncludes,
  RenewalPlanItem,
  RenewalPlanItemInner,
  RenewalPlanLabel,
  RenewalPlanList,
  RenewalPlanName,
  RenewalPlanPriceLabel,
  RenewalPlanPriceLeft,
  RenewalPlanRow,
  SwiperBtn,
  ZipcodeRow,
  ZipcodeSection,
  NewFeatureSection,
  NewFeatureSectionInner,
  MiddleSection,
  ZipcodeCol,
  MiniBanner,
  PlansSection,
  WhySection,
  TopDogsSection,
  CallToActionSection,
  CallToActionRow,
  CallToActionCard,
  CallToActionImage,
} from "./components/styles/Product.styled";
import { ProductDetailModal } from "./components/ProductDetailModal";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import "swiper/css";
import { fetchPlans } from "./api/api";
import qs from "qs";
import { useLocation, useNavigate } from "react-router-dom";
import { GoogleReviewRating } from "./components/GoogleReviewRating";
import "react-tooltip/dist/react-tooltip.css";
import { getBgColor } from "./utils";
import { BASE_URL } from "./components/header";
import { IS_PROD } from "./config";
import { getUtmParameter } from "./common";

const SLIDESPERVIEW_XS = 1;
const SLIDESPERVIEW_MD = 2;
const SLIDESPERVIEW_LG = 3;

const Product = ({
  defaultZipcode,
  utmContentOverride,
  dlEvent,
  googleRating,
  globalSettingsLoaded,
}: {
  defaultZipcode: string;
  utmContentOverride?: string;
  dlEvent?: { event_name: string; event_value: string };
  googleRating: number;
  globalSettingsLoaded: boolean;
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const utmParams = getUtmParameter();
  const appendUtm = (url: string) =>
    utmParams ? `${url}${url.includes("?") ? "&" : "?"}${utmParams}` : url;
  const { t } = useTranslation("product");
  const [zipcodeVal, setZipcodeVal] = useState("");
  const [loading, setLoading] = useState(false);
  const [planList, setPlanList] = useState<any>([]);
  const [planDetail, setPlanDetail] = useState(undefined);
  const [showPlanDetail, setShowPlanDetail] = useState(false);
  const [error, setError] = useState("");
  const [isBeginSlide, setIsBeginSlide] = useState(false);
  const [isEndSlide, setIsEndSlide] = useState(false);
  const [showArrows, setShowArrows] = useState(true);
  const [showPagination, setShowPagination] = useState(true);
  const [selectedUtilityIdx, setSelectedUtilityIdx] = useState<
    number | undefined
  >(undefined);
  const {
    utm_content,
    utm_campaign,
    utm_source,
    utm_medium,
    utm_term,
    zipcode,
    _aiid,
    referral_code,
  } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  const [activeCommunityIdx, setActiveCommunityIdx] = useState(0);
  const sliderRef = useRef<any>(null);
  const communitySliderRef = useRef<any>(null);
  const plansSectionRef = useRef<HTMLDivElement>(null);

  const testimonials = [
    {
      backgroundImage: "/images/community/dallaspets.png",
      backgroundPosition: "top",
      profileImage: "/images/community/dallaspets_img.png",
      handle: "dallaspetsalive",
      quote: t("testimonial1Quote"),
      name: t("testimonial1Name"),
      title: t("testimonial1Title"),
    },
    {
      backgroundImage: "/assets/community/rpm-cover.jpg",
      backgroundPosition: "center",
      profileImage: "/assets/community/rpm-logo.png",
      handle: "rescuedpetsmovement",
      quote: t("testimonial2Quote"),
      name: t("testimonial2Name"),
      title: t("testimonial2Title"),
    },
    {
      backgroundImage: "/images/community/julia.png",
      backgroundPosition: "top",
      profileImage: "/images/community/julia_img.png",
      handle: "juliamoralesclark",
      quote: t("testimonial3Quote"),
      name: t("testimonial3Name"),
      title: t("testimonial3Title"),
    },
  ];

  // Apply utm_content_override when utm_content is absent from the URL
  useEffect(() => {
    if (
      utmContentOverride &&
      !new URLSearchParams(location.search).has("utm_content")
    ) {
      const params = new URLSearchParams(location.search);
      params.set("utm_content", utmContentOverride);
      navigate(
        { pathname: location.pathname, search: params.toString() },
        { replace: true },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [utmContentOverride]);

  // dl_event is now embedded in every funnel_step dataLayer push via
  // funnel_utm_event / funnel_utm_value, so the separate once-per-page
  // sendGTMEventOnce call is no longer needed.

  useEffect(() => {
    console.log("v28th Aug")
    // console.log(zipcode, defaultZipcode)
    if (zipcode) {
      setZipcodeVal(`${zipcode}`);
      handleSearchPlan(`${zipcode}`);
    } else {
      setZipcodeVal(defaultZipcode);
      handleSearchPlan(defaultZipcode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zipcode, defaultZipcode]);

  const funnelStepFiredRef = useRef(false);

  useEffect(() => {
    // Wait for the global settings API to resolve so dlEvent is populated
    // when available. Fire only once. If the API returns no dl_event (e.g.
    // when cookies/storage are cleared), dlEvent stays undefined and the
    // funnel_utm_event/funnel_utm_value fields default to "null".
    if (!globalSettingsLoaded || funnelStepFiredRef.current) return;
    funnelStepFiredRef.current = true;

    //@ts-ignore
    window.dataLayer = window.dataLayer || [];

    console.log("Data in document.referrer ==>", document.referrer);

    if (
      document.referrer === "https://goodcharlierx.com/" ||
      document.referrer === "https://user.petcareclub.vet/"
    ) {
      //@ts-ignore
      window.dataLayer.push({
        event: "petcare_club_funnel",
        funnel_type: "petcare", // fixed value
        funnel_step: "6C", // fixed value
        funnel_name: "to plan page", // fixed value
        funnel_utm_content: utm_content ? `${utm_content}` : "null",
        funnel_utm_event: dlEvent?.event_name || "null",
        funnel_utm_value: dlEvent?.event_value || "null",
      });
    }

    //@ts-ignore
    window.dataLayer.push({
      event: "sales_funnel",
      funnel_type: "plan_page", // fixed value
      funnel_step: "0", // fixed value
      funnel_name: "selected plan", // fixed value
      funnel_utm_content: utm_content ? `${utm_content}` : "null",
      funnel_utm_event: dlEvent?.event_name || "null",
      funnel_utm_value: dlEvent?.event_value || "null",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalSettingsLoaded, dlEvent]);

  const handleSearchPlan = (zip?: string) => {
    const _zipcode = zip || zipcodeVal;

    if (_zipcode) {
      //datalayer script added JIRA 990
      //@ts-ignore
      window.dataLayer = window.dataLayer || [];
      //@ts-ignore
      window.dataLayer.push({
        event: "zipcode_update",
        zipcode: _zipcode, // dynamic value. e.g. '77005'
      });
    }

    if (_zipcode.length === 5 && !loading) {
      setLoading(true);
      setPlanList([]);
      setSelectedUtilityIdx(undefined);
      setError("");

      fetchPlans(
        _zipcode,
        utm_content,
        utm_campaign,
        utm_source,
        utm_medium,
        utm_term,
      ).then((res) => {
        setLoading(false);
        if (res && res.response && res.status !== 0) {
          setPlanList(res.response);

          if (res.response.length === 1) {
            setSelectedUtilityIdx(0);
          }

          // Scroll to plans section after plans are loaded
          setTimeout(() => {
            if (plansSectionRef.current) {
              const headerOffset = 80; // Account for sticky header
              const elementPosition =
                plansSectionRef.current.getBoundingClientRect().top;
              const offsetPosition =
                elementPosition + window.pageYOffset - headerOffset;
              window.scrollTo({ top: offsetPosition, behavior: "smooth" });
            }
          }, 100);
        } else {
          setError(t("errorMessage"));
        }
      });
    }
  };

  const redirectToEnrollment = (val: any) => {
    if (!val || selectedUtilityIdx === undefined) return;
    const { productID } = val;
    const utilityCode =
      planList[selectedUtilityIdx].distributionServiceProvider.utility_code;
    const baseEnrollmentUrl = !IS_PROD
      ? "https://dev-enrollment.goodcharlie.com"
      : "https://enrollment.goodcharlie.com";
    let enrollmentUrl = `${baseEnrollmentUrl}/?utility_code=${utilityCode}&product_id=${productID}`;
    if (utm_content) {
      enrollmentUrl += `&utm_content=${utm_content}`;
    }
    if (utm_campaign) {
      enrollmentUrl += `&utm_campaign=${utm_campaign}`;
    }
    if (utm_source) {
      enrollmentUrl += `&utm_source=${utm_source}`;
    }
    if (utm_medium) {
      enrollmentUrl += `&utm_medium=${utm_medium}`;
    }
    if (utm_term) {
      enrollmentUrl += `&utm_term=${utm_term}`;
    }
    if (_aiid) {
      enrollmentUrl += `&_aiid=${_aiid}`;
    }
    if (referral_code) {
      enrollmentUrl += `&referral_code=${referral_code}`;
    }

    // datalayer script added JIRA 990
    //@ts-ignore
    window.dataLayer = window.dataLayer || [];
    //@ts-ignore
    window.dataLayer.push({
      event: "plan_select",
      zipcode: zipcodeVal, // dynamic value. e.g. '77001',
      prod_name: val?.name, // dynamic value. e.g. 'GoodEnergy 12'
    });
    window.location.href = enrollmentUrl;
  };

  const handleResize = (swiper: any) => {
    const { slides, isBeginning, isEnd } = swiper;
    const numSlides = slides.length;
    const width = window.innerWidth;

    if (width < 768) {
      // console.log(`xs: ${numSlides > SLIDESPERVIEW_XS}`)
      setShowPagination(numSlides > SLIDESPERVIEW_XS);
      setShowArrows(numSlides > SLIDESPERVIEW_XS);
    } else if (width >= 768 && width < 992) {
      // console.log(`md: ${numSlides > SLIDESPERVIEW_MD}`)
      setShowPagination(numSlides > SLIDESPERVIEW_MD);
      setShowArrows(numSlides > SLIDESPERVIEW_MD);
    } else {
      // console.log(`lg: ${numSlides > SLIDESPERVIEW_LG}`)
      setShowPagination(numSlides > SLIDESPERVIEW_LG);
      setShowArrows(numSlides > SLIDESPERVIEW_LG);
    }
    setIsBeginSlide(isBeginning);
    setIsEndSlide(isEnd);
  };

  const handlePaging = (swiper: any) => {
    const { activeIndex, slides } = swiper;
    const numSlides = slides.length;
    const width = window.innerWidth;

    let pages = 0;
    if (width < 768) {
      pages = numSlides - SLIDESPERVIEW_XS;
    } else if (width >= 768 && width < 992) {
      pages = numSlides - SLIDESPERVIEW_MD;
    } else {
      pages = numSlides - SLIDESPERVIEW_LG;
    }

    setIsBeginSlide(activeIndex < 1);
    setIsEndSlide(pages === activeIndex);
  };

  const displayPlanList = () => {
    if (selectedUtilityIdx === undefined) return null;
    if (!planList[selectedUtilityIdx]) return null;

    let [...list] = planList[selectedUtilityIdx].webProducts;

    // const firstPopularProduct = list.find(
    //   (item: any) => item.isFeatured === true
    // );
    return (
      <>
        <Swiper
          spaceBetween={20}
          slidesPerView={SLIDESPERVIEW_XS}
          pagination={showPagination ? { clickable: true } : false}
          modules={[Pagination]}
          centerInsufficientSlides={true}
          onResize={handleResize}
          breakpoints={{
            768: {
              slidesPerView: SLIDESPERVIEW_MD,
            },
            992: {
              slidesPerView: SLIDESPERVIEW_LG,
            },
          }}
          onSlidePrevTransitionEnd={(swiper) => handlePaging(swiper)}
          onSlideNextTransitionEnd={(swiper) => handlePaging(swiper)}
          ref={sliderRef}
        >
          {list.map((val: any, idx: number) => {
            const {
              name,
              // productID,
              isRecommended,
              kwh2000Price,
              contractLengthName,
              contractPeriodName,
              productDisplayFeature5,
              productDisplayShortDescription,
              rawCommodityPrice,
            } = val;

            const rateType = productDisplayShortDescription.split(",")[1];

            return (
              <SwiperSlide key={idx}>
                <RenewalPlanItem recommended={isRecommended}>
                  <RenewalPlanItemInner>
                    {productDisplayFeature5 && (
                      <RenewalPlanLabel
                        style={{
                          backgroundColor: getBgColor(productDisplayFeature5)
                            .bg,
                          border: `1px solid ${getBgColor(productDisplayFeature5).border}`,
                          width: "80%",
                        }}
                      >
                        {productDisplayFeature5.toLowerCase() === 'most popular' ? t('mostPopular') :
                         productDisplayFeature5.toLowerCase() === 'best value' ? t('bestValue') :
                         productDisplayFeature5.toLowerCase() === 'secure savings' ? t('secureSavings') :
                         productDisplayFeature5.toLowerCase() === '100% green' ? t('greenEnergy') :
                         productDisplayFeature5}
                      </RenewalPlanLabel>
                    )}
                    <RenewalPlanName>
                      <b>{name}</b>
                    </RenewalPlanName>
                    <RenewalPlanPriceLeft>
                      <RenewalPlanPriceLabel>
                        {t("averagePrice")}
                      </RenewalPlanPriceLabel>
                      <div>
                        <div>
                          <b>
                            <NumberFormat
                              displayType={"text"}
                              value={kwh2000Price}
                              decimalScale={1}
                              fixedDecimalScale={true}
                            />
                          </b>
                          <i>¢</i>
                        </div>
                        <span className="kwh-label">{t("at2000kWh")}</span>
                      </div>
                      <span>{t("basedOn")} {rawCommodityPrice}¢ {t("energyRate")}</span>
                    </RenewalPlanPriceLeft>
                    <RenewalPlanInfo>
                      <RenewalPlanRow>
                        <label>
                          <img
                            src="/assets/icons/2026/icon_Calender.svg"
                            alt=""
                          />
                          {t("planLength")}
                        </label>
                        <span>{`${
                          contractPeriodName === "Years"
                            ? parseInt(contractLengthName) * 12
                            : contractLengthName
                        } ${t("months")}`}</span>
                      </RenewalPlanRow>
                      {rateType && (
                        <RenewalPlanRow>
                          <label>
                            <img
                              src="/assets/icons/2026/icon_Lock.svg"
                              alt=""
                            />
                            {t("planType")}
                          </label>
                          <span>{rateType}</span>
                        </RenewalPlanRow>
                      )}
                      <RenewalPlanRow>
                        <label>
                          <img
                            src="/assets/icons/2026/icon_Cancel.svg"
                            alt=""
                          />
                          {t("cancelFee")}
                        </label>
                        <span>{t("cancelFeeAmount")}</span>
                      </RenewalPlanRow>
                    </RenewalPlanInfo>
                    <RenewalPlanIncludes>
                      <h4>{t("planIncludes")}</h4>
                      <ul>
                        <li>
                          <img src="/assets/icons/2026/icon_Pets.svg" alt="" />
                          {t("videoVet")}
                        </li>
                        <li>
                          <img src="/assets/icons/2026/icon_Save.svg" alt="" />
                          {t("emergencyFund")}
                        </li>
                        <li>
                          <img
                            src="/assets/icons/2026/icon_Hearts.svg"
                            alt=""
                          />
                          {t("donations")}
                        </li>
                        <li
                          style={{
                            color: "#c14a1e",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                        >
                          <img src="/assets/icons/2026/leash-free.png" alt="" />
                          <a
                            href="https://help.goodcharlie.com/en/articles/15707404-what-is-the-leash-free-trial"
                            target="_blank"
                            style={{ color: "#c14a1e", textDecoration: "none" }} rel="noreferrer"
                          >
                            Leash Free Trial: No cancel fee first 30 days
                          </a>
                        </li>
                      </ul>
                    </RenewalPlanIncludes>
                    <RenewalPlanAction>
                      <Button
                        gcblue
                        onClick={() => {
                          //@ts-ignore
                          window.dataLayer = window.dataLayer || [];
                          //@ts-ignore
                          window.dataLayer.push({
                            event: "plan_details",
                            zipcode: zipcodeVal, // dynamic value. e.g. '77001',
                            prod_name: val.name, // dynamic value. e.g. 'GoodEnergy 12'
                          });
                          setPlanDetail(val);
                          setShowPlanDetail(true);
                        }}
                      >
                        {t("details")}
                      </Button>
                      <Button
                        onClick={() => {
                          redirectToEnrollment(val);
                        }}
                      >
                        {t("select")}
                      </Button>
                    </RenewalPlanAction>
                  </RenewalPlanItemInner>
                </RenewalPlanItem>
              </SwiperSlide>
            );
          })}
        </Swiper>
        {showArrows && (
          <SwiperBtn
            various="prev"
            disabled={isBeginSlide}
            onClick={() => {
              if (!sliderRef.current || isBeginSlide) return;
              const { swiper } = sliderRef.current;
              swiper.slidePrev();
              handlePaging(swiper);
            }}
          >
            <img src="/assets/previous.png" alt="Previous" />
          </SwiperBtn>
        )}
        {showArrows && (
          <SwiperBtn
            various="next"
            disabled={isEndSlide}
            onClick={() => {
              if (!sliderRef.current || isEndSlide) return;
              const { swiper } = sliderRef.current;
              swiper.slideNext();
              handlePaging(swiper);
            }}
          >
            <img src="/assets/next.png" alt="Next" />
          </SwiperBtn>
        )}
      </>
    );
  };

  const displayUtilityDropdown = () => {
    if (planList.length <= 1) return null;
    return (
      <div
        id="utility-dropdown"
        className="d-flex align-items-center justify-content-center"
      >
        <Dropdown>
          <Dropdown.Toggle disabled={loading} variant="outline-secondary">
            {selectedUtilityIdx !== undefined
              ? planList[selectedUtilityIdx].distributionServiceProvider.name
              : t("selectUtility")}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {(planList as Object[]).map((option: any, optionIdx: number) => {
              return (
                <Dropdown.Item
                  eventKey={option.distributionServiceProvider.name}
                  key={optionIdx}
                  onClick={() => {
                    setSelectedUtilityIdx(optionIdx);
                  }}
                  active={selectedUtilityIdx === optionIdx ? true : false}
                >
                  {option.distributionServiceProvider.name}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  return (
    <div id="homepage">
      <div className="first-section">
        <MiniBanner>
          <div className="banner-rating">
            <GoogleReviewRating rating={googleRating} />
          </div>
          <div className="hero-content">
            <img src="/assets/charlie.webp" alt="Charlie" />
            <h1>
              {t("heroTitle").split(" ").slice(0, 3).join(" ")} <br className="mobile-break" />
              {t("heroTitle").split(" ").slice(3).join(" ")}
            </h1>
          </div>
        </MiniBanner>
        <ZipcodeSection>
          <ZipcodeRow>
            <ZipcodeCol>
              <Form.Group>
                <NumberFormat
                  name="zipcode"
                  value={zipcodeVal}
                  maxLength={5}
                  onChange={(evt: any) => setZipcodeVal(evt.target.value)}
                  className="form-control"
                  placeholder={t("enterZipCode")}
                  disabled={loading}
                />
              </Form.Group>
              {displayUtilityDropdown()}
            </ZipcodeCol>
            <Button
              onClick={() => handleSearchPlan()}
              disabled={zipcodeVal.length < 5}
            >
              {t("updatePlans")}
            </Button>
          </ZipcodeRow>
        </ZipcodeSection>
        <PlansSection ref={plansSectionRef}>
          {loading && (
            <div style={{ paddingBottom: 100 }}>
              <LoadingRow />
            </div>
          )}
          {error && <PlanError>{error}</PlanError>}
          {!loading && planList.length > 0 && (
            <RenewalPlanList>{displayPlanList()}</RenewalPlanList>
          )}
        </PlansSection>
      </div>
      <MiddleSection>
        <div className="container">
          <NewFeatureSection>
            <div className="container">
              <div
                style={{
                  padding: "5rem 0",
                }}
              >
                <h2 className="section_title">
                  {t("whyTexansTitle")}
                </h2>
                <p className="subsection_title">
                  {t("whyTexansSubtitle")}
                </p>
              </div>
              <NewFeatureSectionInner>
                <WhySection>
                  {[
                    {
                      image: "/assets/section-why/why_section_01.webp",
                      icon: "/assets/icons/2026/icon_Discount.svg",
                      title: t("straightforwardPricing"),
                      description: t("straightforwardPricingDesc"),
                      imageStyle: { objectPosition: "center -8.5rem" },
                    },
                    {
                      image: "/assets/section-why/why_section_02.webp",
                      icon: "/assets/icons/2026/icon_Pets.svg",
                      title: t("freePetBenefits"),
                      description: (
                        <>
                          {t("freePetBenefitsDesc")} <br />
                          <a
                            href={appendUtm(`${BASE_URL}/pet-perks`)}
                            rel="noreferrer"
                            className="red_link"
                          >
                            {t("seePetPerks")}
                          </a>
                        </>
                      ),
                      imageStyle: { objectPosition: "center center" },
                    },
                    {
                      image: "/assets/section-why/why_section_03.webp",
                      icon: "/assets/icons/2026/icon_Save.svg",
                      title: t("toolsToSave"),
                      description: t("toolsToSaveDesc"),
                      imageStyle: { objectPosition: "center center" },
                    },
                    {
                      image: "/assets/section-why/why_section_04.webp",
                      icon: "/assets/icons/2026/icon_Hearts.svg",
                      title: t("communityImpact"),
                      description: (
                        <>
                          {t("communityImpactDesc")} <br />
                          <a
                            href={appendUtm(`${BASE_URL}/impact`)}
                            rel="noreferrer"
                            className="red_link"
                          >
                            {t("learnMore")}
                          </a>
                        </>
                      ),
                      imageStyle: { objectPosition: "10% center" },
                    },
                    {
                      image: "/assets/section-why/why_section_05.webp",
                      icon: "/assets/section-why/why_icon_05.png",
                      title: t("topPawService"),
                      description: t("topPawServiceDesc"),
                      imageStyle: { objectPosition: "center -160px" },
                    },
                  ].map((item, index) => (
                    <div className="why-item" key={index}>
                      <img
                        src={item.image}
                        alt={`Why section ${index + 1}`}
                        style={{ ...item.imageStyle }}
                      />
                      <div className="why-content">
                        <div className="why-title-row">
                          <img
                            className="why-icon"
                            src={item.icon}
                            alt=""
                            style={{
                              minWidth: "32px",
                              minHeight: "32px",
                              width: "32px",
                              height: "32px",
                            }}
                          />
                          <h3>{item.title}</h3>
                        </div>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  ))}
                </WhySection>
              </NewFeatureSectionInner>
            </div>
          </NewFeatureSection>
        </div>
      </MiddleSection>
      <TopDogsSection>
        <div className="container">
          <div
            style={{
              padding: "2rem 0",
            }}
          >
            <h2 className="section_title">
              {t("trustedTitle")}
            </h2>
            <p className="subsection_title">
              {t("trustedSubtitle")}
            </p>
          </div>
          <CommunityRow>
            {/* Desktop: side-by-side layout with arrows */}
            <CommunityDesktop>
              <CommunityNavBtn
                direction="prev"
                onClick={() => communitySliderRef.current?.swiper?.slidePrev()}
              >
                <img src="/assets/previous.png" alt="Previous" />
              </CommunityNavBtn>
              <Swiper
                spaceBetween={20}
                slidesPerView={1}
                watchSlidesProgress={true}
                modules={[Pagination]}
                ref={communitySliderRef}
              >
                {testimonials.map((item, index) => (
                  <SwiperSlide key={index}>
                    <CommunityItem>
                      <CommunityItemImage
                        style={{
                          backgroundImage: `url("${item.backgroundImage}")`,
                          backgroundPosition: item.backgroundPosition,
                        }}
                      />
                      <CommunityItemContent>
                        <CommunityItemContentHeader>
                          <img
                            src={item.profileImage}
                            width="40"
                            height="40"
                            alt=""
                            style={{
                              objectFit: "cover",
                              borderRadius: "50%",
                            }}
                          />
                          <span>{item.handle}</span>
                          <img
                            src="/images/community/verified_tick.png"
                            width="16"
                            height="16"
                            alt=""
                          />
                        </CommunityItemContentHeader>
                        <p>"{item.quote}"</p>
                        <CommunityItemContentFooter>
                          <h6>{item.name}</h6>
                          <p>{item.title}</p>
                        </CommunityItemContentFooter>
                      </CommunityItemContent>
                    </CommunityItem>
                  </SwiperSlide>
                ))}
              </Swiper>
              <CommunityNavBtn
                direction="next"
                onClick={() => communitySliderRef.current?.swiper?.slideNext()}
              >
                <img src="/assets/next.png" alt="Next" />
              </CommunityNavBtn>
            </CommunityDesktop>

            {/* Mobile: image-only slider with content card below */}
            <CommunityMobile>
              <Swiper
                spaceBetween={20}
                slidesPerView={1.15}
                centeredSlides={true}
                watchSlidesProgress={true}
                modules={[Pagination]}
                onSlideChange={(swiper) =>
                  setActiveCommunityIdx(swiper.realIndex)
                }
              >
                {testimonials.map((item, index) => (
                  <SwiperSlide key={index}>
                    <CommunityItemImage
                      className="community-image"
                      style={{
                        backgroundImage: `url("${item.backgroundImage}")`,
                        backgroundPosition: item.backgroundPosition,
                      }}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
              <CommunityItemContent>
                <CommunityItemContentHeader>
                  <img
                    src={testimonials[activeCommunityIdx].profileImage}
                    width="40"
                    height="40"
                    alt=""
                    style={{ objectFit: "cover", borderRadius: "50%" }}
                  />
                  <span>{testimonials[activeCommunityIdx].handle}</span>
                  <img
                    src="/images/community/verified_tick.png"
                    width="16"
                    height="16"
                    alt=""
                  />
                </CommunityItemContentHeader>
                <p>"{testimonials[activeCommunityIdx].quote}"</p>
                <CommunityItemContentFooter>
                  <h6>{testimonials[activeCommunityIdx].name}</h6>
                  <p>{testimonials[activeCommunityIdx].title}</p>
                </CommunityItemContentFooter>
              </CommunityItemContent>
            </CommunityMobile>
          </CommunityRow>
        </div>
      </TopDogsSection>
      <CallToActionSection>
        <div className="container">
          <CallToActionRow>
            <CallToActionCard>
              <h2>{t("leashFreeTitle")}</h2>
              <p>{t("leashFreeDescription")}</p>
              <Button
                 as="a"
                 href="https://help.goodcharlie.com/en/articles/15707404-what-is-the-leash-free-trial"
                 target="_blank"
                 rel="noopener noreferrer"
                 className="text-decoration-none"
              >
                {t("leashFreeLearnMore")}
              </Button>
            </CallToActionCard>
            <CallToActionImage>
              <img src="/images/doginleash.png" alt="" />
            </CallToActionImage>
          </CallToActionRow>
        </div>
      </CallToActionSection>
      <ProductDetailModal
        data={planDetail}
        show={showPlanDetail}
        handleClose={() => {
          setShowPlanDetail(false);
        }}
        handleGoEnroll={(val: any) => {
          redirectToEnrollment(val);
        }}
      />
    </div>
  );
};

export default Product;
